import { render, staticRenderFns } from "./ViewMemberSidebar.vue?vue&type=template&id=2ccef149&scoped=true"
import script from "./ViewMemberSidebar.vue?vue&type=script&lang=js"
export * from "./ViewMemberSidebar.vue?vue&type=script&lang=js"
import style0 from "./ViewMemberSidebar.vue?vue&type=style&index=0&id=2ccef149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccef149",
  null
  
)

export default component.exports